import clsx from "clsx";

/** Barre d'avancement ou de remplissage (R0 : composant unique) : rail `canvas` de 6 px, remplissage arrondi qui
 *  glisse en douceur (`--gx-enter`), ton d'état (`run` tâche en cours, `ok`, `warn`, `danger`, `accent`).
 *  `value` de 0 à 1 ; `label` est lu par les lecteurs d'écran (`role="progressbar"`). */
export function ProgressBar({
  value,
  tone = "accent",
  label,
  className,
}: {
  value: number;
  tone?: "accent" | "run" | "ok" | "warn" | "danger";
  label: string;
  /** Marges et largeur seulement. */
  className?: string;
}) {
  const pct = Math.round(Math.max(0, Math.min(1, Number.isFinite(value) ? value : 0)) * 100);
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      className={clsx("h-1.5 w-full overflow-hidden rounded-full bg-canvas", className)}
    >
      <div
        className={clsx(
          "h-full rounded-full transition-[width] duration-(--gx-enter) ease-out motion-reduce:transition-none",
          { accent: "bg-accent", run: "bg-run", ok: "bg-ok", warn: "bg-warn", danger: "bg-danger" }[tone],
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
